import { sumBy } from 'lodash'

import { Table, Text } from '@/ui'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { formatCurrency, centsToDollars } from '@/utils/currencyHelpers'
import { AllocationGuide } from '@/src/reducers/finances/allocationGuidesReducer'
import { TypographyStyles } from '@/styles'

interface Props {
  allocationGuide: AllocationGuide | undefined
  profits: number
}

export const AllocationGuideAmountsTable = ({
  allocationGuide,
  profits,
}: Props) => {
  const totalAmount = () => {
    if (allocationGuide) {
      return sumBy(Object.values(allocationGuide.amounts), (amt) =>
        centsToDollars(amt.amountInCents)
      )
    } else {
      return 0
    }
  }

  const calculatedTotal = totalAmount()
  return (
    <>
      <Table className="w-full mb-4 table-fixed">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="w-1/2">
              Allocation Name
            </Table.HeaderCell>
            <Table.HeaderCell className="w-1/2">
              Amount Allocated
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {allocationGuide?.amounts &&
            Object.values(allocationGuide.amounts).map((amount) => (
              <Table.Row key={amount.id}>
                <Table.Cell className="w-1/2">
                  {amount.allocationRuleName}
                </Table.Cell>
                <Table.Cell className="w-1/2">
                  <CurrencyFormatLabel
                    value={formatCurrency(centsToDollars(amount.amountInCents))}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>

      <Table className="w-full table-fixed">
        <Table.Body>
          <Table.Row>
            <Table.Cell className="w-1/2">
              <Text variant={TypographyStyles.H3}>Total</Text>
            </Table.Cell>
            <Table.Cell className="w-1/2">
              <Text variant={TypographyStyles.H3}>
                <CurrencyFormatLabel value={formatCurrency(calculatedTotal)} />
              </Text>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className="w-1/2">
              <i>Unallocated Profits</i>
            </Table.Cell>
            <Table.Cell className="w-1/2">
              <i>
                <CurrencyFormatLabel
                  value={formatCurrency(profits - calculatedTotal)}
                />
              </i>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </>
  )
}
